import './blocks.scss'

import {BlocksType} from 'campagne/types'
import React, {FunctionComponent} from 'react'
import {style} from 'util/campagne/style'
import ImageBlock from './blocks/imageblock'
import QuoteBlock from './blocks/quoteblock'
import TextBlock from './blocks/textblock'
import VideoBlock from './blocks/videoblock'

const styles = style('blocks')

const Blocks: FunctionComponent<{
	blocks: BlocksType
}> = ({blocks}) => (
	<div class={styles}>
		{blocks.map((block) => {
			switch (block.type) {
				case 'imageblock':
					return <ImageBlock {...block} />
				case 'quoteblock':
					return <QuoteBlock {...block} />
				case 'textblock':
					return <TextBlock {...block} />
				case 'videoblock':
					return <VideoBlock {...block} />
				case 'custom':
					return block.render()
			}
		})}
	</div>
)
export default Blocks

export const Block: FunctionComponent<{className?: string}> = ({
	children,
	className
}) => <div class={styles('block').with(className)}>{children}</div>
